export const sources = {
  LAYER_LIST: 'uf.ui.layers.layer_list',
  LAYER_MANAGER: 'uf.ui.layers.layer_manager',
};
